
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import VerifyEmailAddress from '~/components/EmailVerification/VerifyEmailAddress.vue';
import AcceptTermsAndConditions from '~/components/Home/AcceptTermsAndConditions.vue';
import GalaChainMigrationAlert from '~/components/Home/GalaChainMigrationAlert.vue';
import CreateWalletModalPrompt from '~/components/NewWallet/CreateWalletModalPrompt.vue';
import TwoFactorAuthPrompt from '~/components/ModalPrompts/TwoFactorAuthSetupPrompt.vue';

@Component({
  components: {
    VerifyEmailAddress,
    AcceptTermsAndConditions,
    GalaChainMigrationAlert,
    CreateWalletModalPrompt,
    TwoFactorAuthPrompt,
  },
})
export default class DashboardModals extends Vue {
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
}
